import { Injectable } from '@angular/core';
import { SnackBarService } from '@app-core/services/snackbar/snack-bar.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class DownloadService {
  constructor(private snackbarService: SnackBarService, private translate: TranslateService) {}

  public onDownloadVideos(incident: any): void {
    if (!incident?.mediaFiles || incident.mediaFiles.length === 0) {
      this.snackbarService.failure(this.translate.instant('commonIncidentDownloadVideoFailure'));
      return;
    }

    const mediaFiles = incident.mediaFiles.filter((file) => file?.mediaFile);

    if (mediaFiles.length === 0) {
      this.snackbarService.failure(this.translate.instant('commonIncidentDownloadVideoFailure'));
      return;
    }

    const downloadFile = async (index: number) => {
      if (index >= mediaFiles.length) return;

      const mediaFileUrl = mediaFiles[index].mediaFile;
      if (!mediaFileUrl) {
        console.warn(`Invalid media URL at index ${index}`);
        this.snackbarService.failure(this.translate.instant('commonIncidentDownloadVideoFailure'));
      }

      const fileName = `video_${index + 1}.mp4`;
      const fragment = new DocumentFragment();
      const companion_app_platform = localStorage.getItem('companion-app-platform');
      const companion_app_token = localStorage.getItem('companion-app-access-token');

      try {
        const a = document.createElement('a');
        a.href = mediaFileUrl;
        a.download = fileName;
        fragment.appendChild(a);
        a.click();
        fragment.removeChild(a);
        setTimeout(() => downloadFile(index + 1), 1000);

        const w = window as any;
        const data = {
          message: 'download video from mobile',
          status: 'success',
          url: mediaFileUrl,
          filename: fileName,
        };
        if (companion_app_platform === 'ios') {
          w?.webkit?.messageHandlers?.nativeDownloadVideo.postMessage(data);
        } else {
          w?.Android?.nativeDownloadVideo(JSON.stringify(data));
        }
        if (!companion_app_token) {
          this.snackbarService.success(this.translate.instant('commonIncidentDownloadVideoSuccessfully'));
        }
      } catch (error) {
        console.error('Error downloading video:', error);

        const companion_app_platform = localStorage.getItem('companion-app-platform');
        const w = window as any;
        const data = {
          message: 'download video from mobile ',
          status: 'failure',
        };
        if (companion_app_platform === 'ios') {
          w?.webkit?.messageHandlers?.nativeDownloadVideo.postMessage(data);
        } else {
          w?.Android?.nativeDownloadVideo(JSON.stringify(data));
        }

        if (!companion_app_token) {
          this.snackbarService.failure(this.translate.instant('commonIncidentDownloadVideoFailure'));
        }
      }
    };

    downloadFile(0);
  }
}
